
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { t } from '@app/dev/helpers/translator';

const DateCountdown = ({ seconds: propsSeconds }) => {
    const [diffSeconds, setDiffSeconds] = useState(propsSeconds);

    useEffect(() => {
        setDiffSeconds(propsSeconds);
    }, [propsSeconds]);

    useEffect(() => {
        const timeout = setTimeout(() => setDiffSeconds(diffSeconds - 1), 1000);
        return () => clearTimeout(timeout);
    }, [diffSeconds]);

    const [
        days,
        hours,
        minutes,
        seconds,
    ] = useMemo(() => {
        const date = moment.duration(diffSeconds * 1000);
        return [
            date.days(),
            date.hours(),
            date.minutes(),
            date.seconds(),
        ];
    }, [diffSeconds]);

    return <div className="date-countdown">
        {days}
        <sup>{t('D')}</sup>

        {hours}
        <sup>{t('H')}</sup>

        {minutes}
        <sup>{t('M')}</sup>

        {seconds}
        <sup>{t('S')}</sup>
    </div>;
};

DateCountdown.propTypes = {
    seconds: PropTypes.number.isRequired,
};

export default DateCountdown;